"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformType = void 0;
var PlatformType;
(function (PlatformType) {
    PlatformType["WEB"] = "WEB";
    PlatformType["IOS"] = "IOS";
    PlatformType["ANDROID"] = "ANDROID";
    PlatformType["API"] = "API";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
//# sourceMappingURL=platformType.js.map